import { CampaignActionEligibility } from './types';
import { globalGetService } from '@/utils/globalApiServices';

export const getCampaignActionEligibility = async (
  campaignUids: string[],
  upstreamCnpUid?: string
): Promise<Record<string, CampaignActionEligibility>> => {
  const response = await globalGetService(
    'csp/cnpChain/campaignActionEligibility',
    {
      campaignUid: campaignUids.join(','),
      upstreamCnpUid,
    }
  );
  return response?.ok
    ? (response.data as Record<string, CampaignActionEligibility>)
    : {};
};
